import Home from '@/views/Antagonist/Home';

export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/logowanie',
    name: 'login',
    component: () => import(/* webpackChunkName: "antagonist.login" */ '@/views/Antagonist/Login.vue'),
  },
];
